import React, { useState, useRef } from 'react';
import { useApp } from "../context/AppContext";
import { useTranslation } from "../context/TranslationContext";

import PopupMenu from './PopupMenu';

import '../styles/Address.css';

import { ReactComponent as AssetIconEdit } from '../resources/assets/iconNavigate.svg'; 

const Address = ({ value }) => {
    const { t } = useTranslation();
    const { appSendMessage } = useApp();
    const [showPopup, setShowPopup] = useState(false);
    const iconRef = useRef(null);

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
    };

    const handleOpenMaps = () => {
        if (value.url) {
            appSendMessage("openURL", value.url);
        }
        setShowPopup(false);
    };

    const popupOptions = [
        { label: t.addressPopup.copyAddress, onClick: () => copyToClipboard(value.address) },
        { label: t.addressPopup.copyGPS, onClick: () => copyToClipboard(`${value.lat}, ${value.lng}`) },
        { label: t.addressPopup.openMaps, onClick: handleOpenMaps }
    ];

    return (
        <div className='address-panel'>
            <div className='address-text'>{value.address}</div>
            <div ref={iconRef} className='address-navigate' onClick={() => setShowPopup(!showPopup)}>
                <div className='address-navigate-icon'>
                    <AssetIconEdit />
                    {showPopup && <PopupMenu anchor={iconRef.current} options={popupOptions} onClose={() => setShowPopup(false)} className="address-popup" />}
                </div>
            </div>
        </div>
    );
};

export default Address;